import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButton} from 'mui-tiptap';
import constants from 'helpers/constants';

const StyledEditorMenuButtonFormatting = styled(MenuButton)`
  &.EditorMenuButtonFormatting-collapsed {
    &:not(${props => props.theme.state2Selector('EditorMenuButtonFormatting', null, ['hover', 'active', 'focus', 'focusVisible', 'selected'], '')}) {
      color: ${props => props.theme.palette.divider};
    }
    ${props => props.theme.color2Css('EditorMenuButtonFormatting', null, 'default', {
      varPrefix: 'editor-menu-button-formatting',
      interactive: true,
      childPrefix: '',
      flatten: true,
      type: constants.colorTypes.accentBackground
    })}
    ${props => props.theme.state2Selector('EditorMenuButtonFormatting', null, ['hover', 'active', 'focus', 'focusVisible', 'selected'])} {
      box-shadow: inset 0 0 1px ${props => props.theme.property('palette.divider')};
    }
  }
  
  ${ComponentStyles}
`;

StyledEditorMenuButtonFormatting.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonFormatting;
